import React, { useLayoutEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import { IPlotlyGraph } from 'utils';
import { useWindowSize } from 'hooks';

const PlotlyGraph = ({ data, layout, frames, height = 520, legendPosition }: IPlotlyGraph) => {
    const [currentWidth, setCurrentWidth] = useState<number | undefined>(0);
    const [width] = useWindowSize();

    useLayoutEffect(() => {
        const mainPlotContainerWidth = document?.getElementById(
            `PlotGraphContainer-${legendPosition}`,
        )?.offsetWidth;
        setCurrentWidth(mainPlotContainerWidth);
    }, [width, legendPosition]);

    return (
        <Plot
            data={data}
            layout={{
                ...layout,
                height: height,
                width: currentWidth,
                autosize: true,
                font: {
                    fontFamily: 'Inter',
                    size: 12,
                    fontStyle: 'normal',
                },
            }}
            useResizeHandler={true}
            frames={frames}
            config={{ responsive: true, autosizable: true, displayModeBar: false }}
        />
    );
};

function areEqual(prevProps: any, nextProps: any) {
    return prevProps.data === nextProps.data && prevProps.layout === nextProps.layout;
}

export default React.memo(PlotlyGraph, areEqual);
